import React, { useMemo } from 'react';
import { Card, Table, Tag, Progress, Typography } from 'antd';
import LogoCloud from "../../Components/Graphics/LogoCloud";
import Dot from "../../Components/Dot";
import TickerChip from "../../Components/TickerChip";
import {useEnsureTickersLoaded} from "../../hooks/useEnsureTickersLoaded";
import {useScreenHeight} from "../../hooks/useScreen";

const XrayTable = ({ data, etfColors, sectorColors }) => {
  const symbols = useMemo(() => data.map(x => x.symbol), [data]);
  const { tickers, loading } = useEnsureTickersLoaded(symbols);
  const screenHeight = useScreenHeight();
  console.log('ETF COLORS', etfColors)


  const dataWithLogos = data.map(item => {
    const ticker = tickers.find(ticker => ticker.symbol === item.symbol);
    return {
      ...item,
      logo: ticker?.logo || null, // Fallback to null if logo is missing
      name: ticker?.name || 'N/A', // Fallback to 'N/A' if name is missing
    };
  }).sort((a, b) => b.wgt - a.wgt);


  // Handle top symbols with a safeguard for missing logos
  let topSymbols = dataWithLogos
    .sort((a, b) => b.mktcap - a.mktcap)
    .map(x => x.symbol)
    .slice(0, 10)
    .map(symbol => tickers.find(t => t.symbol === symbol))
    .filter(ticker => ticker && ticker.logo) // Ensure only tickers with logos are included
    .map(ticker => ticker.logo);

  const columns = [
    {
      title: "Security",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <div>
          <TickerChip ticker={record} />
        </div>
      ),
      fixed: 'left'
    },
    {
      title: 'Weight (%)',
      dataIndex: 'wgt',
      key: 'wgt',
      render: (text) => (
        <div className="progress-cell">
          <Progress
              type={'dashboard'}
              size={'small'}
              percent={(text * 100).toFixed(2)}
              strokeColor={{
                '0%': '#108ee9',
                '20%': '#87d068',
              }} />
        </div>
      ),
    },
    {
      title: 'Sector',
      dataIndex: 'sector',
      key: 'sector',
      render: sector => (
            <Tag color={sectorColors[sector]}>{sector}</Tag>
      ),
    },
    {
    title: 'Industry',
        dataIndex: 'industry',
        key: 'industry',
        render: industry => (
            <Tag bordered={false} >{industry}</Tag>
        ),

    },
    {
      title: 'ETF Parents',
      dataIndex: 'parents',
      key: 'parents',
      render: parents => (
      <>
        {parents.length > 0 && parents.map((parent) => (
          <Tag key={parent} bordered={false} style={{background: '#FFFFFF'}}>
            <Dot color={etfColors[parent]} label={parent.toUpperCase()} />
          </Tag>
        ))}
      </>
    ),
    },
  ];

  return (
        <Card
            bordered={false}
            title={
                <div className={'px-5'}>
                  <Typography.Title level={3}>Consolidated Single-Stock View</Typography.Title>
                </div>
            }
            style={{maxWidth: '80%', margin: 'auto'}}
        >
          <LogoCloud spacing={'16px'} srcs={topSymbols} size={'64px'} direction={'horizontal'} />
          <Table
            className={'vertical-align-middle'}
            columns={columns}
            dataSource={dataWithLogos}
            rowKey="symbol"
            pagination={{
                pageSize: 100
            }}
            scroll={{y: screenHeight-50, x: 'max-content'}}
          />
        </Card>
  )
};

export default XrayTable;
